import React, { useEffect, } from 'react';
import { Link, useParams, Redirect, } from 'react-router-dom';

import PrivateHeader from 'containers/parts/PrivateHeader';
import { mappedProps } from 'containers/student/StudyCurriculum';
import SiteMain from 'containers/parts/SiteMain';
import CorrectAnswerCount from 'components/student/common/CorrectAnswerCount';

const nl2br = require('react-nl2br');

const StudyCurriculum: React.FC<mappedProps> = (props: mappedProps) => {
  const { curriculum_id } = useParams<{curriculum_id: string}>();

  const curriculum = curriculum_id && props.getCurriculum(curriculum_id)

  useEffect(() => {
    props.fetchStudyAchievementsLatest();
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  , []);

  useEffect(() => {
    if (curriculum) {
      props.fetchData(curriculum.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curriculum_id]);

  if (!curriculum) {
    return <Redirect to='/' />;
  }

  const page = props.getRecord(curriculum.id)

  return (
    <React.Fragment>
      <PrivateHeader />
      <SiteMain>
        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          <li className="breadcrumbs__item">
            { curriculum.name}
          </li>
        </ol>

        <div className="site-main__main-contents">
          <div className="page-title">
            { curriculum.name }
            <div className={'page-title__correct-count'}>
              {props.student.studyAchievementsLatest.record && <>
                <CorrectAnswerCount correctAnswerCount={props.student.studyAchievementsLatest.record.study_achievements.consecutive_correct_answer_count}/>
            </>}
          </div>
          </div>

          {
            //MARK: 教科：数学、物理 の場合のみ表示
            (curriculum.id === 1 || curriculum.id === 3) &&
            <div className="page-title__additional-info">
              <p>
                コンプリートとなっているトピックの教材を再び学習する場合は、AI理解度判定のレベルが下がった状態から開始します。
              </p>
            </div>
          }

          <div className="page-subtitle">
            科目
          </div>

          <ul className="subject-list">
            { page && page.courses.map(course => (
              <li key={course.id} className="subject-list__item">
                {
                  course.title.length <= 8 ?
                  <Link to={`/study/courses/${course.id}`} className="subject-list__link">
                    { course.title }
                  </Link>:
                  <Link
                    to={`/study/courses/${course.id}`}
                    className="subject-list__link subject-list__link--multi-line"
                  >
                    { nl2br(course.title.replace('　', '\n') ) }
                  </Link>
                }
              </li>
            ))}
          </ul>

          <div className="back-home">
            <Link to='/' className="back-home__link">マイページへ戻る</Link>
          </div>
        </div>

        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          <li className="breadcrumbs__item">
            { curriculum.name}
          </li>
        </ol>
      </SiteMain>
    </React.Fragment>
  );
}

export default StudyCurriculum